import { Roles } from '../utils/enums/Roles';
import { GlobalSettings } from '../utils/getGlobalSettings';
import { createMandatoryContext } from './createMandatoryContext';

export interface IAppContext {
    languageCode: string;
    emailAddress?: string;
    userRole: Roles;
    isClient: boolean;
    isDroneOperator?: boolean;
    companyId?: string;
    userId?: string;
    globalSettings: GlobalSettings;
    shouldEnforceMfa?: boolean;
    useProductTitle?: boolean;
    areLabelsVisibleInOverviews?: boolean;
}

export const appContext = createMandatoryContext<IAppContext>();
